import { Box, Flex } from '@/@diffrag/components/base'
import { Button } from '@/components/ui/button'
import { toast } from '@/lib/toast'
import { cn } from '@/lib/utils'
import React from 'react'
import { FormProvider } from '../form/FormProvider'
import { useNavigate } from 'react-router-dom'

type Props = {
  children?: React.ReactNode
  className?: string
  onSave?: () => Promise<void>
  cancel?: boolean
}

export const ContentView = ({ children, className, onSave, cancel }: Props) => {
  const navigate = useNavigate()

  return (
    <FormProvider>
      <Box
        as={onSave ? 'form' : 'div'}
        className={cn(
          'flex flex-1 flex-col  gap-2 bg-slate-100 p-4 overflow-hidden',
          className,
        )}
      >
        {children}
      </Box>
      {onSave && (
        <Flex
          align="center"
          justify="end"
          gap={8}
          className="fixed bottom-0 left-[240px] z-10 h-16 w-[calc(100vw-240px)] border-t border-slate-200 bg-white px-4"
        >
          {cancel && (
            <Button
              variant="outline"
              onClick={() => {
                navigate(-1)
              }}
              className="w-[100px] "
            >
              취소
            </Button>
          )}

          {onSave && (
            <Button
              form="form"
              type="submit"
              onClick={() => {
                try {
                  onSave()
                  toast.success('저장되었습니다.')
                } catch (error) {
                  toast.error('저장 실패')
                }
              }}
              className="w-[100px] bg-[#007bff] hover:bg-[#007bff]/90"
            >
              저장
            </Button>
          )}
        </Flex>
      )}
    </FormProvider>
  )
}
